import { Spinner } from '@tiendanube/components';
import React from 'react';
import Center from '../Center';

interface SpinnerInterface {
  show?: boolean;
}

function SpinnerStratus({ show = true }: SpinnerInterface): JSX.Element {
  return (
    <>
      {show && (
        <Center>
          <Spinner size="large" />
        </Center>
      )}
    </>
  );
}

export default SpinnerStratus;
